import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import { FC } from 'react';

interface BillingPortalModalProps {
  open: boolean;
  onClose: () => void;
}

const BILLING_PORTAL_URL = 'https://billing.aktify.com/portal/aktify839';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
};

export const BillingPortalModal: FC<BillingPortalModalProps> = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <Stack sx={style} spacing={3}>
      <Typography variant="h6" component="h2">
        Redirecting to Aktify Billing Portal
      </Typography>
      <Typography>
        By clicking the proceed button below, you will be taken to Aktify&apos;s Billing Portal. You
        will need a separate user account for the Billing Portal. If you don&apos;t already have an
        account for the Billing Portal, please work with your Aktify account executive to get set up
        in the Billing Portal.
      </Typography>
      <Box display="flex" flexDirection="row" justifyContent="flex-end" gap={1}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          component="a"
          href={BILLING_PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
        >
          Proceed
        </Button>
      </Box>
    </Stack>
  </Modal>
);
